<template>
    <div>
        <div class="site">
            <div class="sitename">{{areas.length > 0 ? areas.find(item=>item.areaId==$route.params.id).areaName : ''}}
            </div>
            <div class="changesite">
                <div>
                    <div class="changesite_icon" @click="showSite = !showSite"></div>
                    <div class="changesite_text" @click="showSite = !showSite">切换站点</div>
                </div>
                <div class="goback" @click="$router.push({path: '/'})">
                    <div class="goback_icon"></div>
                    <div class="goback_text">返回总览</div>
                </div>
            </div>
        </div>
        <div class="siteList" v-if="showSite">
            <div class="siteListContainer">
                <div class="title">
                    <div class="siteTitle">站点列表</div>
                    <div class="closeSiteList" @click="showSite = false"></div>
                </div>
                <div class="search">
                    <input type="text" placeholder="请输入关键词" v-model="areaFilterText">
                    <img src="../../assets/img/search.png" alt="">
                </div>
                <div class="siteData">
                    <template v-for="(item,index) in areas">
                        <div class="siteItem" :key="index" v-if="areaFilter(item)"
                            @click="$router.push({ path: `/Site/${item.areaId}`})">
                            <img class="siteIcon" :src="item.areaImg" alt="" />
                            <div class="siteName" :class="{ active: item.areaId == areaId }">
                                {{item.areaName}}
                            </div>
                        </div>
                    </template>
                    <template v-if="showAreaNumber === 0">
                        <span style="color: #8c939d;font-size: 18rem">暂无数据</span>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        GetAllAreas,
    } from "@/components/Request";

    export default {
        name: "ChangeSite",
        components: {},
        props: ["areaId"],
        data() {
            return {
                showSite: false,
                areas: [],
                areaFilterText: "",
                showAreaNumber: 0,
            };
        },
        beforeCreate() {
            GetAllAreas({
                projectId: this.$store.state.projectId
            }).then(({
                data
            }) => {
                this.areas = data.data.areas
                this.showAreaNumber = data.data.areas.length
            })
        },
        watch: {
            areaFilterText(n, o) {
                if (!n) {
                    this.showAreaNumber = this.areas.length
                } else {
                    this.showAreaNumber = this.areas.filter(area => {
                        return area.areaName.indexOf(n) !== -1
                    }).length
                }
            },
        },
        methods: {
            areaFilter(item) {
                if (!this.areaFilterText) {
                    return true
                }
                return item.areaName.indexOf(this.areaFilterText) !== -1
            },
        },
    };
</script>


<style lang="less" scoped>
    .site {
        width: 4000/192vw;
        height: 1300/108vh;
        position: fixed;
        top: 960/108vh;
        left: 400/192vw;
        background-image: url(../../assets/img/site_bg.png);
        background-size: 100% 100%;

        .sitename {
            font-size: 36rem;
            font-family: YouSheBiaoTiHei;
            color: #e6f3fd;
            margin-top: 250/108vh;
            margin-left: 240/192vw;
        }

        .changesite {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 3600/192vw;
            height: 160/108vh;
            font-size: 16rem;
            color: #e6f3fd;
            margin-left: 240/192vw;

            .changesite_icon {
                width: 160/192vw;
                height: 130/108vh;
                background-image: url(../../assets/img/change.png);
                background-size: 100% 100%;
                cursor: pointer;
                display: inline-block;
            }

            .changesite_text {
                white-space: nowrap;
                cursor: pointer;
                display: inline-block;
                margin-left: 80/192vw;
            }

            .goback {
                .w(88);
                .h(18);
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                .goback_icon {
                    .w(18);
                    .h(18);
                    background-image: url(../../assets/img/park.png);
                    background-size: 100% 100%;
                }

                .goback_text {
                    margin-left: 80/192vw;
                    white-space: nowrap;
                }
            }
        }
    }

    .siteList {
        width: 4000/192vw;
        height: 5120/108vh;
        background-image: url(../../assets/img/站点列表.png);
        background-size: 100% 100%;
        position: fixed;
        top: 960/108vh;
        left: 4480/192vw;

        .siteListContainer {
            width: 90%;
            height: 90%;
            position: relative;
            top: 5%;
            left: 5%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .title {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .siteTitle {
                    font-size: 18rem;
                    color: #ffffff;
                }

                .closeSiteList {
                    width: 190/192vw;
                    height: 180/108vh;
                    background-image: url(../../assets/img/close.png);
                    background-size: 100% 100%;
                    cursor: pointer;
                }
            }

            .search {
                .h(42);
                .w(362);
                margin-top: 200/108vh;
                margin-bottom: 250/108vh;
                overflow: hidden;
                border-radius: 20px;
                border: 1px solid rgba(255, 255, 255, 0.3);
                position: relative;

                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;

                input {
                    width: 100%;
                    height: 100%;
                    padding: 0 200/192vw;
                    font-size: 16rem;
                    outline: 0;
                    border: none;
                    background: rgba(0, 0, 0, 0.15);
                    color: #e6f3fd;
                    font-weight: 400;
                    line-height: 420/108vh;
                }

                img {
                    margin-right: 100/192vw;
                    cursor: pointer;
                    z-index: 99;
                }
            }

            .siteData {
                width: 100%;
                height: 80%;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                align-items: center;

                .siteItem {
                    width: 100%;
                    height: 420/108vh;
                    margin-bottom: 250/108vh;
                    font-size: 18rem;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    cursor: pointer;

                    .siteName {
                        margin-left: 170/192vw;
                        color: #fff;
                    }

                    .siteIcon {
                        width: 420/192vw;
                        height: 390/108vh;
                        background-size: 100% 100%;
                    }

                    .active {
                        color: rgba(13, 148, 255, 1)
                    }
                }
            }
        }
    }

    .siteData::-webkit-scrollbar {
        width: 50/192vw;
        height: 1px;
    }

    .siteData::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    // .siteData::-webkit-scrollbar-track {
    //     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    //     border-radius: 10px;
    //     background: #111;
    // }
</style>